import SelectionState from "state/selections/SelectionState";
import { selectEnableAsOfDate } from "state/misc/selectors";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { deleteAsOfDate } from "state/misc/actions";

export const useColumnDefinitions = () => {
  const enableAsOfDate = useSelector(
    selectEnableAsOfDate(SelectionState.COMMITTED)
  );
  const dispatch = useDispatch();
  return React.useMemo(() => {
    const columnDefs = [];
    if (enableAsOfDate) {
      columnDefs.push({
        headerName: "As of Date",
        colId: "misc-asOfDate",
        field: "misc-asOfDate",
        X_onDelete: () => dispatch(deleteAsOfDate(false)),
      });
    }
    return columnDefs;
  }, [dispatch, enableAsOfDate]);
};
